var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({ position: 'relative' })},[(_vm.loading)?_c('v-progress-linear',{staticClass:"mb-4",attrs:{"indeterminate":""}}):_vm._e(),_vm._t("default"),(_vm.loading)?_c('v-overlay',{attrs:{"absolute":"","opacity":"0.5","color":"white"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }